import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadImage } from '../redux/ImageUploadSlice';

const ImageUpload = ({ label, initialImages = [], onImageUpload, onError, maxSizeMB = 1, accept = ".jpeg,.jpg,.png,.webp", acceptedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"] }) => {
    const dispatch = useDispatch();
    const { status, uploadProgress } = useSelector((state) => state.imageUpload);
    const [gallery, setGallery] = useState(initialImages);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setGallery(initialImages);
    }, [initialImages]);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const newImages = [];

        files.forEach((file) => {
            
            if (file.size > maxSizeMB * 1024 * 1024) {
                onError(`File size exceeds ${maxSizeMB} MB`);
                return;
            }
            
            if (!acceptedTypes.includes(file.type)) {
                onError("Invalid file type selected");
                return;
            }
            newImages.push(file);
        });

        if (newImages.length > 0) {
            uploadFiles(newImages);
        }
    };

    const uploadFiles = async (files) => {
        setIsLoading(true);
        for (const file of files) {
            try {
                const data = await dispatch(uploadImage(file)).unwrap();
                console.log('data', data);
                setGallery((prev) => {
                    console.log('prev', prev);
                    const updatedGallery = [...prev, data.fileUrl];
                    console.log('updatedGallery', updatedGallery);
                    onImageUpload(updatedGallery); // Ensure form state is updated
                    return updatedGallery;
                });
            } catch (error) {
                // Show specific error message from the API response
                const errorMessage = error?.payload?.message ||
                    error?.response?.data?.message ||
                    error?.message ||
                    'Error uploading file. Please try again.';
                onError(errorMessage);
                console.error('Image upload error:', error);
            }
        }
        setIsLoading(false);
    };

    const handleDelete = (index) => {
        setGallery((prev) => {
            const updatedGallery = prev.filter((_, i) => i !== index);
            onImageUpload(updatedGallery);
            return updatedGallery;
        });
    };

    return (
        <div className="relative flex flex-col items-center justify-center w-full">
            {label && <label className="mb-2 text-sm text-gray-500">{label}</label>}

            <div className="relative flex items-center justify-center w-full">
                <label htmlFor="image-upload" className="relative flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                    <div className="flex flex-col items-center justify-center">
                        {isLoading || status === 'loading' ? (
                            <p className="text-sm text-gray-500">Uploading... {uploadProgress}%</p>
                        ) : (
                            <>
                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag & drop</p>
                                <p className="text-xs text-gray-500">Allowed: {accept} (Max {maxSizeMB}MB)</p>
                            </>
                        )}
                    </div>
                    <input id="image-upload" type="file" multiple className="hidden" accept={accept} onChange={handleFileChange} />
                </label>
            </div>

            {/* Image Gallery */}
            <div className="mt-4 grid grid-cols-3 gap-4">
                {gallery.map((fileUrl, index) => {

                    const extension =
                        fileUrl
                            .split("?")[0]
                            .split(".")
                            .pop()
                            ?.toLowerCase();

                    const isImage = ["jpg", "jpeg", "png", "webp"].includes(extension);

                    return (

                        <div key={index} className="relative w-32 h-32 border rounded">
                            {
                                isImage ? (
                                    <img src={fileUrl} alt="" className="object-cover w-full h-fullrounded"
                                    />

                                ) : (

                                    <div className="flex h-full flex-col items-center justify-center p-3 text-center">
                                        <div className="mb-2 text-4xl">
                                            {extension === "pdf"
                                                ? "📄"
                                                : extension === "doc"
                                                    ? "📝"
                                                    : extension === "docx"
                                                        ? "📝"
                                                        : "📁"}
                                        </div>

                                        <div className="break-all text-xs font-semibold">
                                            {fileUrl
                                                .split("/")
                                                .pop()
                                                ?.substring(0, 25)}
                                        </div>
                                    </div>

                                )
                            }

                            <button
                                onClick={() => handleDelete(index)}
                                className="absolute top-1 right-1 bg-red-600 text-white rounded-full px-2"
                            >
                                ×
                            </button>

                        </div>

                    );

                })}
                
            </div>
        </div>
    );
};

export default ImageUpload;